import React from 'react';
import { ShoppingBag } from 'lucide-react';
import { useCart } from '@/contexts/CartContext';

export default function CartButton({ className = '', testId = 'cart-button' }) {
  const { count, setOpen } = useCart();
  return (
    <button
      data-testid={testId}
      onClick={() => setOpen(true)}
      aria-label="Carrito"
      className={`relative h-10 px-3 inline-flex items-center gap-1 rounded-full border border-[#FF7597]/30 text-[#1F1A24] hover:bg-[#FF2D9C] hover:text-white hover:border-[#FF2D9C] transition-all ${className}`}
    >
      <ShoppingBag className="w-4 h-4" />
      {count > 0 && (
        <span
          data-testid="cart-count"
          className="absolute -top-1.5 -right-1.5 min-w-[20px] h-5 px-1.5 rounded-full bg-[#FF2D9C] text-white text-[10px] font-black flex items-center justify-center shadow-md"
        >
          {count}
        </span>
      )}
    </button>
  );
}
